<template>
  <div class="shiming-container">
    <div class="con-box">
      <!-- 面包屑导航 -->
      <div class="breadcrumb">
        <span class="breadcrumb-item" @click="goToProfile">个人中心</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item" @click="goToProfile">个人资料</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item active">实名认证</span>
      </div>

      <!-- 实名认证表单 -->
      <div class="shiming-form">
        <div class="form-item">
          <label class="form-label">姓名</label>
          <el-input
            v-model="formData.real_name"
            placeholder="请输入你的真实姓名"
            class="form-input"
            :disabled="loading"
          />
        </div>

        <div class="form-item">
          <label class="form-label">身份证号码</label>
          <el-input
            v-model="formData.id_card"
            placeholder="请输入你的身份证号码"
            class="form-input"
            :disabled="loading"
          />
        </div>

        <el-button
          type="primary"
          class="verify-btn"
          :loading="loading"
          @click="handleVerify"
        >
          {{ loading ? '认证中...' : '立即认证' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { realNameAuth } from '@/api/user'

export default {
  name: 'Shiming',
  data() {
    return {
      formData: {
        real_name: '',
        id_card: ''
      },
      loading: false
    }
  },
  methods: {
    goToProfile() {
      this.$router.push('/profile/index')
    },
    // 表单验证
    validateForm() {
      if (!this.formData.real_name.trim()) {
        this.$message.error('请输入真实姓名')
        return false
      }
      if (!this.formData.id_card.trim()) {
        this.$message.error('请输入身份证号码')
        return false
      }
      // 简单的身份证号码格式验证
      const idCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!idCardPattern.test(this.formData.id_card)) {
        this.$message.error('请输入正确的身份证号码')
        return false
      }
      return true
    },
    // 处理实名认证
    async handleVerify() {
      if (!this.validateForm()) {
        return
      }

      this.loading = true
      try {
        const response = await realNameAuth({
          real_name: this.formData.real_name.trim(),
          id_card: this.formData.id_card.trim()
        })

        if (response && response.code === 1) {
          this.$message.success('实名认证成功！')
          // 认证成功后跳转到个人资料页面
          this.$router.push('/profile/index').then(() => {
            // 跳转成功后刷新页面数据
            window.location.reload()
          })
        }
      } catch (error) {
        console.error('实名认证失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.shiming-container {
  height: calc(100vh - var(--navbar-total-height, 80px));
  height: calc(100dvh - var(--navbar-total-height, 80px));
  background: #F5F5F5;
  padding: 20px;
}

.con-box {
  width: var(--page-inner-ratio, 80%);
  margin: 0 auto;
  border-radius: 10px;
  padding: 24px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  font-size: 14px;
  color: #606266;
  background: #fff;
  padding: 20px;
}

.breadcrumb-item {
  cursor: pointer;
  color: #606266;
  transition: color 0.3s;
}

.breadcrumb-item:hover {
  color: #1E80FF;
}

.breadcrumb-item.active {
  color: #303133;
  cursor: default;
}

.breadcrumb-item.active:hover {
  color: #303133;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #C0C4CC;
}

.shiming-form {
  background: #fff;
  padding: 20px;
  margin: 0 auto;
}

.form-item {
  margin:0 auto 24px;
  max-width: 60%;

}

.form-label {
  display: block;
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
}

.verify-btn {
  width: 60%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(135deg, #1E80FF 0%, #0F71E3 100%);
  border: none;
  margin: 0 auto 16px;
  display: block;
}

.verify-btn:hover {
  background: linear-gradient(135deg, #0F71E3 0%, #1E80FF 100%);
}
</style>
